export default class {

    /*@ngInject*/
    constructor($http, ORDENES_URL){
        Object.assign(this, {$http, ORDENES_URL});
    }

    getOrdenesPendientes(limit){
        return this.$http.get(this.ORDENES_URL + '/pendientes?limit=' + limit);
    }

    getOrdenesEnProceso(limit){
        return this.$http.get(this.ORDENES_URL + '/en-proceso?limit=' + limit);
    }

    getOrdenesFinalizadas(limit){
        return this.$http.get(this.ORDENES_URL + '/historial?limit=' + limit);
    }

    getOrden(id){
        return this.$http.get(this.ORDENES_URL + '/' + id);
    }

    cambiarEstadoOrden(id, estado){
        return this.$http.post(this.ORDENES_URL + '/estado/' + id, estado);
    }
}



// WEBPACK FOOTER //
// ./client/app/ordenes-route/ordenes.service.js